<template>
  <div id="legendModal" class="c-modal">
    <div class="c-modal__content">
      <span class="c-modal__close">&times;</span>
      <div v-if="this.$store.state.lang === 'en'">
        <h3>Legend</h3>
        <table>
          <tbody>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/abstrahlwinkel.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Beam angle</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/da_68.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Cut out (e. g.: Ø 68 mm)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/lm_led.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Lamp (e.g.: LED)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/cri_90.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Color rendering index (e.g.: CRI>90)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/dim.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>dimmable (e.g.: trailing edge)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/dim_dali.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>DALI dimmable</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/ip_54.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Ingress protection (e. g.: IP54)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/schutzklasse_3.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Protection class (e. g. III)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/ik_10.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Impact protection (e. g.: IK10)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/dim_to_warm.svg" />
              </td>
              <td style="vertical-align:middle">
                <span
                  >dim to warm (light quality and dim characteristics of a
                  conventional light bulb combined with the efficiency of the
                  LED technology)</span
                >
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/led_lumen.svg" />
              </td>
              <td style="vertical-align:middle">
                <span
                  >Lumen data are nominal value (luminous flux of a LED-module
                  at 25°C operating temperature)<br />Latest luminous flux data
                  and EULUMDAT on request.</span
                >
              </td>
            </tr>
            <tr>
              <td colspan="2"><br />All dimensions in mm</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h3>Legende</h3>
        <table>
          <tbody>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/abstrahlwinkel.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Abstrahlwinkel</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/da_68.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Ausschnittmaß (z. B.: Ø 68 mm)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/lm_led.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Leuchtmittel (z. B.: LED)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/cri_90.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Farbwiedergabeindex (z. B.: CRI>90)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/dim.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>dimmbar (z. B.: Phasenabschnitt)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/dim_dali.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>DALI dimmbar</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/ip_54.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Schutzart (z. B.: IP54)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/schutzklasse_3.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Schutzklasse (z. B.: III)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/ik_10.svg" />
              </td>
              <td style="vertical-align:middle">
                <span>Stoßfestigkeitsgrad (z. B.: IK10)</span>
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/dim_to_warm.svg" />
              </td>
              <td style="vertical-align:middle">
                <span
                  >dim to warm (Lichtqualität und Dimmverhalten einer
                  herkömmlichen Glühlampe kombiniert mit der Energieeffizienz
                  der LED Technologie)</span
                >
              </td>
            </tr>
            <tr>
              <td style="width: 80px">
                <img width="50" src="media/led_lumen.svg" />
              </td>
              <td style="vertical-align:middle">
                <span
                  >Lumenwerte sind Nominalwerte (Lichtstrom eines LED-Moduls bei
                  25°C Betriebstemperatur)<br />Aktuelle Lichtstromwerte und
                  EULUMDAT auf Anfrage.</span
                >
              </td>
            </tr>
            <tr>
              <td colspan="2"><br />Alle Maßangaben in mm</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
